"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOccupiedTableStatus = void 0;
const domain_1 = require("@oolio-group/domain");
const utils_1 = require("./utils");
const updateOccupiedTableStatus = prevState => {
    if (![domain_1.OrderStatus.IN_PROGRESS, domain_1.OrderStatus.ON_HOLD].includes(prevState.status)) {
        return prevState;
    }
    const tables = (0, utils_1.getTablesFromOrder)(prevState).map(table => {
        var _a;
        if ((table === null || table === void 0 ? void 0 : table.status) === domain_1.TableStatus.OCCUPIED ||
            (table === null || table === void 0 ? void 0 : table.status) === domain_1.TableStatus.DONE_SOON) {
            return table;
        }
        const newStatus = !((_a = prevState === null || prevState === void 0 ? void 0 : prevState.orderItems) === null || _a === void 0 ? void 0 : _a.length)
            ? domain_1.TableStatus.SEATED
            : domain_1.TableStatus.OCCUPIED;
        return { ...table, status: newStatus };
    });
    return tables && tables.length > 0
        ? { ...prevState, table: tables[0], tables }
        : prevState;
};
exports.updateOccupiedTableStatus = updateOccupiedTableStatus;
//# sourceMappingURL=updateOccupiedTableStatus.js.map